import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n-composable';
import { useRoute } from 'vue-router/composables';
import { breadcrumbRoutes, routesLabels, topicsLabels } from '@/constants/routes/routes';
import './styles/breadcrumb.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {

const { t } = useI18n();
const rte = useRoute();
const path = ref(rte.fullPath);
/**
 * Splits the current path to be displayed in the breadcrumb
 * Routes with parameters (add?id=55) are simplified with the regex to remove everything after the ?
 */
const getItems = computed(() => path.value.split('/').filter(level => level)
  .map((level: string) => ({
    text: t(routesLabels[level.replace(/\?.*$/, '')]) || t(topicsLabels[level]),
    exact: true,
    disabled: !breadcrumbRoutes[level],
    to: breadcrumbRoutes[level]
  })));

watch(
  () => rte.fullPath,
  () => {
    path.value = rte.fullPath;
  },
  { deep: true }
);


return { __sfc: true,t, rte, path, getItems }
}

})